export const INITIAL_FORM = {
  username: "",
  password: "",
  rememberMe: true,
  forgotEmail: "",
};
